import BaseService from "@/shared/base.service";

import { useAlertStore } from "@/stores/alert.store";

import type { Integration } from "@/types/model/integration";
import { IntegrationParams } from "@/types/request/getIntegration";
import type { IntegrationResponse } from "@/types/response/integration";

export class IntegrationService {
  static async GetAllIntegrations(
    payload: IntegrationParams
  ): Promise<IntegrationResponse | null> {
    try {
      const params = { ...payload };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<IntegrationResponse>(
        `integration`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetAllIntegrations:", error);
      return null;
    }
  }

  static async GetIntegrationById(
    integration_id: string
  ): Promise<IntegrationResponse | null> {
    try {
      const params = {
        integration_id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<IntegrationResponse>(
        `integration`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetIntegrationById:", error);
      return null;
    }
  }

  static async CreateIntegration(payload: object): Promise<Integration | null> {
    try {
      const response = await BaseService.post<Integration>(
        `integration`,
        payload
      );

      if (response) {
        useAlertStore().show("success", "Integração criada com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in CreateIntegration:", error);
      return null;
    }
  }

  static async TurnOnOfIntegration(
    integration_id: string
  ): Promise<Integration | null> {
    try {
      const params = {
        integration_id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<Integration>(
        `turn_on_off_integrations`,
        queryParams
      );

      if (response) {
        useAlertStore().show("success", "Integração atualizada com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in TurnOnOfIntegration:", error);
      return null;
    }
  }

  static async PlayIntegration(
    integration_id: string
  ): Promise<Integration | null> {
    try {
      const params = {
        integration_id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.post<Integration>(
        `on_demand_execution`,
        queryParams
      );

      if (response) {
        useAlertStore().show("success", "Integração atualizada com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in PlayIntegration:", error);
      return null;
    }
  }

  static async UpdateIntegration(payload: object): Promise<Integration | null> {
    try {

      const params = {
        ...payload
      }

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.put<Integration>(
        `integration`,
        queryParams
      );

      if (response) {
        useAlertStore().show("success", "Integração atualizada com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in UpdateIntegration:", error);
      return null;
    }
  }

  static async DeleteIntegration(
    integration_id: string
  ): Promise<Integration | null> {
    try {
      const response = await BaseService.delete<Integration>(
        `integration?integration_id=${integration_id}`
      );

      if (response) {
        useAlertStore().show("warning", "Integração removida com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in DeleteIntegration:", error);
      return null;
    }
  }
}
